(() => {
  gsap.registerPlugin(ScrollTrigger);

  const animations = [
    {
      target: ".Index_custom_image_detail_block_innerboths_new",
      from: { scale: 0, opacity: 0 },
      to: {
        scale: 1,
        opacity: 1,
        duration: 2.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".Index_custom_image_detail_main_new",
          start: "25% bottom", 
          // markers: true,
          end: "75% center",
          scrub: true,
          toggleActions: "play reverse play reverse",
        },
      },
    },
    {
      target: ".Index_tab_feature_collect_block_innerdetail_mainicons_new",
      from: { scale: 0, opacity: 0 },
      to: {
        scale: 1,
        opacity: 1,
        duration: 2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".Index_tab_feature_collect_block_innerdetail_mainicons_new",
          start: "top 100%",
          end: "bottom 10%",
          scrub: true,
        },
      },
    },
    {
      target: ".Index_object_compare_list_innersides_innerleft_innerblock_mainboths_new",
      from: { scale: 0, opacity: 0 },
      to: {
        scale: 1,
        opacity: 1,
        duration: 2,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".Index_object_compare_list_innersides_innerleft_innerblock_mainboths_new",
          start: "top 100%",
          end: "bottom 10%",
          scrub: true,
        },
      },
    },
    {
      target: ".Product_object_features_mainmedia_new",
      from: { scale: 0, opacity: 0 },
      to: {
        scale: 1,
        opacity: 1,
        duration: 2.5,
        ease: "power2.out",
        scrollTrigger: {
          trigger: ".Product_object_features_main_new",
          start: "25% bottom", 
          // markers: true,
          end: "75% center",
          scrub: true,
          toggleActions: "play reverse play reverse",
        },
      },
    },
  ];

  animations.forEach(({ target, from, to }) => {
    gsap.fromTo(target, from, to);
  });
})();

  // {
  //   target: ".Index_custom_image_detail_block_innerboths_innericons_new > div",
  //   from: { scale: 0, opacity: 0 },
  //   to: {
  //     scale: 1,
  //     opacity: 1,
  //     duration: 2.5,
  //     ease: "power2.out",
  //     scrollTrigger: {
  //       trigger: ".Index_custom_image_detail_main_new",
  //       start: "25% bottom", 
  //       // markers: true,
  //       end: "75% center",
  //       scrub: true,
  //       toggleActions: "play reverse play reverse",
  //     },
  //   },
  // },